"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliderNotAtAllToVeryBurdensome = exports.sliderVeryEasyToVeryDifficult = exports.sliderNotAtAllToVeryInteresting = exports.sliderTooShortToTooLong = void 0;
exports.sliderTooShortToTooLong = {
    labels: [
        {
            fr: 'Trop court',
            en: 'Too short'
        },
        {
            fr: 'Juste comme il faut',
            en: 'Just right'
        },
        {
            fr: 'Trop long',
            en: 'Too long'
        }
    ],
    minValue: -10,
    maxValue: 100,
    formatLabel: (value, language) => {
        return value < 0 ? '' : `${value} ${language === 'fr' ? '%' : language === 'en' ? '%' : ''}`;
    },
    trackClassName: 'input-slider-green-yellow-red'
};
exports.sliderNotAtAllToVeryInteresting = {
    labels: [
        {
            fr: 'Pas du tout',
            en: 'Not at all'
        },
        {
            fr: 'Neutre',
            en: 'Neutral'
        },
        {
            fr: 'Très intéressante',
            en: 'Very interesting'
        }
    ],
    minValue: -10,
    maxValue: 100,
    formatLabel: (value, language) => {
        return value < 0 ? '' : `${value} ${language === 'fr' ? '%' : language === 'en' ? '%' : ''}`;
    },
    trackClassName: 'input-slider-red-yellow-green'
};
exports.sliderVeryEasyToVeryDifficult = {
    labels: [
        {
            fr: 'Très facile',
            en: 'Very easy'
        },
        {
            fr: 'Modérément difficile',
            en: 'Moderately difficult'
        },
        {
            fr: 'Très difficile',
            en: 'Very difficult'
        }
    ],
    minValue: -10,
    maxValue: 100,
    formatLabel: (value, language) => {
        return value < 0 ? '' : `${value} ${language === 'fr' ? '%' : language === 'en' ? '%' : ''}`;
    },
    trackClassName: 'input-slider-green-yellow-red'
};
exports.sliderNotAtAllToVeryBurdensome = {
    labels: [
        {
            fr: 'Pas du tout',
            en: 'Not at all'
        },
        {
            fr: 'Modérément pénible',
            en: 'Moderately burdensome'
        },
        {
            fr: 'Très pénible',
            en: 'Very burdensome'
        }
    ],
    minValue: -10,
    maxValue: 100,
    formatLabel: (value, language) => {
        return value < 0 ? '' : `${value} ${language === 'fr' ? '%' : language === 'en' ? '%' : ''}`;
    },
    trackClassName: 'input-slider-green-yellow-red'
};
